import Channel from '@/shared/classes/channels/channel'

const searchByName = (query: string, arrayToFilter: Channel[]) => {
    const filteredChannels = arrayToFilter.filter(
        (channel: Channel) =>
            channel.name.toLowerCase().includes(query.toLowerCase()) ||
            query.toLowerCase().includes(channel.name.toLowerCase())
    )
    return filteredChannels
}

export { searchByName }
